declare let ssr;

export const createAppConfig = (): any => {
  // @ts-ignore
  return ssr ? (global as any).window.config : window.config;
};
